/**
 * CancelProcessingModal — an explicit, blocking "processing" modal shown while
 * the cancel POST is in flight (after the operator clicks "Cancel workshop &
 * notify N", before success/error resolves). A full-viewport scrim blocks all
 * interaction; a centered card shows an animated {@link Spinner} + a clear
 * message. Accessible: `role="status"` + `aria-busy` + `aria-live` so assistive
 * tech announces the in-progress state.
 *
 * This is a transient state owned by the cancel flow — it replaces nothing in
 * the success (cancelled banner) / error (picker stays open, mapped message)
 * transitions; it only covers the pending window.
 */
import { Spinner } from '../../primitives';

export interface CancelProcessingModalProps {
  /** The in-progress message. Defaults to the cancel-flow copy. */
  message?: string;
}

export function CancelProcessingModal({
  message = 'Cancelling workshop & notifying customers…',
}: CancelProcessingModalProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label={message}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 70,
        padding: 24,
      }}
    >
      <div
        className="nb-card"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 14,
          padding: 28,
          maxWidth: 360,
          textAlign: 'center',
        }}
      >
        <Spinner size={32} thickness={3} />
        <div style={{ fontSize: 13, color: 'var(--nb-ink)', lineHeight: 1.5 }}>{message}</div>
      </div>
    </div>
  );
}
